import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aae11f5a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=aae11f5a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aae11f5a')) {
      api.createRecord('aae11f5a', component.options)
    } else {
      api.reload('aae11f5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aae11f5a", function () {
      api.rerender('aae11f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/userAgreement/edit/index.vue"
export default component.exports